import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../assests/css/customer/OrderSuccess.css';
import UserMasterLayout from '../../../Layouts/UserMasterLayout/UserMasterLayout';

const OrderSuccess = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();

  const recommendedProducts = [
    {
      id: 1,
      name: 'Premium Headphones',
      price: 'pkr129.00',
      image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop'
    },
    {
      id: 2,
      name: 'Studio Lamp',
      price: 'pkr54.00',
      image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=400&h=400&fit=crop'
    },
    {
      id: 3,
      name: 'Mechanical Keyboard',
      price: 'pkr89.00',
      image: 'https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=400&h=400&fit=crop'
    },
    {
      id: 4,
      name: 'Steel Bottle',
      price: 'pkr28.00',
      image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=400&h=400&fit=crop'
    }
  ];

  const handleViewOrder = () => {
    navigate(`/order-details/${orderId || '12345'}`);
  };

  const handleContinueShopping = () => {
    navigate('/products');
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <UserMasterLayout>
      <div className="os-container">
        {/* Back and Home Navigation */}
        <div className="os-nav">
          <button className="os-nav-back" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back
          </button>
          <button className="os-nav-home" onClick={() => navigate('/')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Home
          </button>
        </div>

        {/* Success Card */}
        <div className="os-success-card">
          {/* Success Icon */}
          <div className="os-success-icon">
            <div className="os-success-icon-bg">
              <div className="os-success-icon-circle">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Success Message */}
          <h1 className="os-title">Thank You for Your Purchase!</h1>
          <p className="os-order-text">
            Your order <span className="os-order-number">#{orderId || '12345'}</span> has been placed successfully.
          </p>
          <p className="os-confirmation-text">
            A confirmation email has been sent to your inbox. It should arrive within the next few minutes.
          </p>

          {/* Action Buttons */}
          <button className="os-view-order-btn" onClick={handleViewOrder}>
            View Order Summary
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
              <path d="M7 7H17M7 12H17M7 17H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>

          <button className="os-continue-shopping" onClick={handleContinueShopping}>
            Continue Shopping
          </button>
        </div>

        {/* You Might Also Like Section */}
        <div className="os-recommendations">
          <h2 className="os-recommendations-title">YOU MIGHT ALSO LIKE</h2>
          <div className="os-products-grid">
            {recommendedProducts.map((product) => (
              <div 
                key={product.id} 
                className="os-product-card"
                onClick={() => handleProductClick(product.id)}
              >
                <div className="os-product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="os-product-info">
                  <h3 className="os-product-name">{product.name}</h3>
                  <p className="os-product-price">{product.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </UserMasterLayout>
  );
};

export default OrderSuccess;